
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/srp/[...categoryOrLocation]",
      function () {
        return require("private-next-pages/srp/[...categoryOrLocation]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/srp/[...categoryOrLocation]"])
      });
    }
  